import { render, staticRenderFns } from "./AppPubPostCat.vue?vue&type=template&id=66903b60&"
import script from "./AppPubPostCat.vue?vue&type=script&lang=js&"
export * from "./AppPubPostCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports